import React, { useState, useEffect, useRef } from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Radio from '@mui/material/Radio';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import endpoints, { getBackendUrl } from '../../../endpoints';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux'
import CloseIcon from '@mui/icons-material/CloseRounded';

export default function SelectPromptModal(props) {
    const [fullList, setFullList] = useState([])
    const [categories, setCategories] = useState([])
    const [category, setCategory] = useState()
    const categoryRef = useRef()
    const [selected, setSelected] = useState(props.selectedPrompt)
    
    useEffect(() => {
        getFullList()
    }, []);
    
    const token = useSelector((state) => state.auth.token)

    const getFullList = async () => {        
        let uri = getBackendUrl(endpoints.prompts, token)

        try {
            let res = await axios.get(uri)
            setFullList(res.data.items)
            
            const data = []
            res.data.items.map((row) => {
                if (row.type == 'category') {
                    data.push({
                        id: row.id,
                        name: row.content,
                    })
                }
            })
            
            setCategories(data)
            if (res.data.items.length) {
                setCategory(res.data.items[0])
            }
        } catch (e) {
            setFullList([])
        }
    }
    
    const categoryOnChange = (e) => {
        const id = e.target.value
        const c = fullList.find((item) => (item.id == id))
        setCategory(c)
    }
        
    return (
        <Dialog 
            open={props.selectedPrompt ? true : false}
            sx={{ minHeight: 400 }}
            onClose={() => {props.onClose()}} 
            fullWidth
        >
            <DialogTitle id="alert-dialog-title">
                Select Prompt
                <IconButton
                    onClick={props.onClose}
                    sx={{
                      position: 'absolute',
                      right: 8,
                      top: 8,
                      color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={2}>
                    <FormControl variant="standard" fullWidth>
                        <InputLabel id="categoryLabel">Category</InputLabel>
                        <Select
                            fullWidth
                            labelId="categoryLabel"
                            name="category"
                            inputRef={categoryRef}
                            onChange={categoryOnChange}
                            value={category ? category.id : ''}
                        >
                        {categories.map((row) => (
                            <MenuItem key={row.id} value={row.id}>{row.name}</MenuItem>
                        ))}
                        </Select>
                    </FormControl>            
                    <TableContainer sx={{ maxHeight: 300 }}>
                        <Table>
                            <TableBody>
                                {(category ? category.children : []).map((row) => (
                                <TableRow 
                                    hover 
                                    key={row.id} 
                                    sx={{ cursor: 'pointer'}}
                                    selected={(selected && (selected.id == row.id)) ? true : false}
                                >
                                    <TableCell padding="checkbox" sx={{p:0}}>
                                        <Radio
                                            checked={(selected && (selected.id == row.id)) ? true : false}
                                            value={row.id}
                                            onClick={() => {setSelected(row)}}
                                        />
                                    </TableCell>
                                    <TableCell 
                                        sx={{ whiteSpace: 'pre-wrap', width: '100%', p:1 }}
                                        onClick={() => {setSelected(row)}}
                                    >
                                        {row.content}
                                    </TableCell>
                                </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {props.onClose()}}>Close</Button>
                <Button 
                    disabled={(selected && selected.id) ? false : true} 
                    onClick={() => {
                        props.onSelect(selected)
                        setSelected(null)
                    }}
                    autoFocus
                >
                    Done
                </Button>
            </DialogActions>
        </Dialog>
    )
}